export function string2PositiveInt(value) {
    try {
        // 处理 undefined、null、空字符串
        if (value == null || value === '' || value === undefined)
            return undefined;
        const num = Number(value);
        // 处理 NaN 和小于1的情况
        if (isNaN(num) || num < 1)
            return undefined;
        return Math.floor(num);
    }
    catch (error) {
        return undefined;
    }
}
export function stringToFloat(value) {
    try {
        const num = Number(value);
        return !isNaN(num) && num !== 0 ? num : undefined;
    }
    catch (error) {
        return undefined;
    }
}
/**
 * 格式化浮点数展示：小数部分为 .00 时省略为整数，否则保留原始小数
 * 返回 number 类型，异常兜底返回 0
 * @example
 * formatFloat(123.00) => 123
 * formatFloat(123.50) => 123.5
 * formatFloat(123.45) => 123.45
 */
export function formatFloat(value) {
    try {
        // 用取模判断是否为整数，避免浮点数精度问题（如 0.1+0.2 !== 0.3）
        if (value % 1 === 0) {
            return Math.floor(value);
        }
        return value;
    }
    catch (_error) {
        return 0;
    }
}
/**
 * R007：当前积分/总积分 → 进度百分比；总积分为 0 时按 0 处理（避免除零）
 * @example
 * computeProgress(51, 100) => 51
 * computeProgress(10, 0) => 0
 */
export function computeProgress(current, total) {
    return total > 0 ? current / total * 100 : 0;
}
/**
 * R007：进度展示格式化：最多保留 3 位小数并去除尾随 0
 * @example
 * formatProgress(51.000) => 51
 * formatProgress(62.100) => 62.1
 * formatProgress(44.444) => 44.444
 */
export function formatProgress(value) {
    return formatFloat(Number(value.toFixed(3)));
}
